import axios from "axios";
import { STORE_SETUP } from "../configs/apiConfig";
import { BaseResponseSingle } from "../typings";
import { IStoreSetup } from "../typings/interfaces/responses/store-setup-response";
import { setStoreSetup } from "./store-header";

/** Loads the store's Store Setup for printouts; keeps the defaults if it fails. */
export const loadStoreSetup = async (storeId: number, merchantId: number) => {
  try {
    const res = await axios.get<BaseResponseSingle<IStoreSetup>>(STORE_SETUP(storeId, merchantId));
    if (res.data?.status === "SUCCESS") setStoreSetup(res.data.body);
  } catch {
    // Printouts keep the defaults
  }
};
